import ListSearchController from '../support/list_search_controller'

// Client-side name filter for the agents list. The list is fully server-rendered
// (and the Active/All segment filter re-renders it server-side), so filtering is a
// show/hide pass over rows already in the DOM — each row carries its downcased name
// in data-name. connect() re-applies so a server re-render lands filtered, not stale.
export default class extends ListSearchController {}
